export * from './api/api';
export * from './model/models';
export * from './variables';
export * from './configuration';
export * from './api.module';


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/data/blog-client-api/index.ts